import React from "react";
import SectionHeading from "./SectionHeading";
import { SOCIAL_LINKS } from "./data/content";
import { FaGithub, FaLinkedin, FaDribbble } from "react-icons/fa";
import { useIntersectionObserver } from "./useIntersectionObserver";

const ICONS = {
  github: FaGithub,
  linkedin: FaLinkedin,
  dribbble: FaDribbble,
};

function Contact() {
  const ref = React.useRef(null);
  const linkedIn = SOCIAL_LINKS.find((link) => link.type === "linkedin");
  const [inView] = useIntersectionObserver(ref);

  return (
    <section
      id="contact"
      className={"site-section site-section--contact" + (inView ? " section-is-visible" : "")}
      ref={ref}
    >
      <div className="section-inner">
        <SectionHeading
          label="Contact"
          title="Get in touch"
          description="Have a question or want to connect? Reach out on LinkedIn — always happy to chat about web development."
        />

        <div className="contact-panel glass-card reveal-item">
          <div className="contact-panel-copy">
            <p>
              The best way to reach me is LinkedIn — send me a message there.
              You can also find me on GitHub and Dribbble.
            </p>
          </div>

          {linkedIn && (
            <a
              href={linkedIn.href}
              className="contact-cta-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin aria-hidden="true" />
              Message on LinkedIn
            </a>
          )}

          <div className="contact-socials">
            {SOCIAL_LINKS.map((link) => {
              const Icon = ICONS[link.type];
              return (
                <a
                  key={link.type}
                  href={link.href}
                  className="contact-social-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={link.label}
                >
                  <Icon aria-hidden="true" />
                  <span>{link.label}</span>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
